"use strict";

import Vue from "vue";
import axios from "axios";

// axios.defaults.baseURL = process.env.VUE_APP_BASE;
// window.location.origin + "/" + process.env.VUE_APP_BASE;

const config = {
  baseURL:
    process.env.VUE_APP_REWARD_NNETWORK === "testnet" ||
    process.env.VUE_APP_REWARD_NNETWORK === "test"
      ? process.env.VUE_APP_OPTIONS
      : window.location.origin,
  // baseURL: window.location.origin,
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // config.headers.post["Content-Type"] = "application/json";
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function ({ data, status }) {
    if (status === 200) {
      switch (data.code) {
        case 200:
          return Promise.resolve(data.data);
      }
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
